module.exports = __webpack_public_path__ + "static/media/pageTop.a26b61a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/pageTop.svg
// module id = 183
// module chunks = 0